import React from 'react'

const TickIcon = ({dataTestId}) => (
    <svg className="fill-mint-green bg-white"
         data-testid={dataTestId}
         focusable="false"
         viewBox="0 0 24 24"
         aria-hidden="true"
    >
        <path
            d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z">
        </path>
    </svg>
)

const IconContent = ({index, activeStep, reviewComplete}) => {
    if (reviewComplete) {
        // show grayed out steps
        return (
            <div className={'rounded-full w-6 h-6 text-center content-center bg-gray-400'}>
                <span
                    className={`font-bold text-[0.75rem]  text-gray-100`}>
                    {index + 1}
                </span>
            </div>
        )
    }

    return (
        <div
            className={`rounded-full w-6 h-6 text-center content-center  ${index > activeStep ? 'bg-gray-400' : 'bg-mint-green'} `}>
            {activeStep > index ? (
                    // show tick icon for completed steps
                    (<TickIcon dataTestId={`stepper-tick-icon:${index}`}/>)
                ) :
                (
                    // show step numbers, light gray background for future steps
                    (<span className={`font-bold text-[0.75rem]  ${index > activeStep ? 'text-gray-100' : ''}`}>
                        {index + 1}
                    </span>)
                )
            }
        </div>
    );
}
export default function Stepper({activeStep, formSteps, reviewComplete}) {
    return (
        <div className="p-0 flex flex-row items-start">
            {
                formSteps.map((item, index) => (
                    <div className='px-2 max-sm:w-10 flex relative flex-col flex-1 items-center'
                         key={`stepper:${index}}`}>
                        <div className='flex flex-col items-center w-full'>
                            <div
                                className='relative flex flex-col items-center w-full'
                                data-testid={`stepper-step:${index}`}
                            >
                                <IconContent index={index} activeStep={activeStep} reviewComplete={reviewComplete}/>
                                {
                                    index + 1 !== Object.keys(formSteps).length &&
                                    <hr className={' absolute top-[50%]  left-[calc(50%+20px)] mx-0 bg-gray-300 border-0 h-[1px] m-0  w-[calc(100%-30px)]'}/>
                                }
                            </div>
                            <div
                                className={`text-center text-sm leading-[1.43] w-full mt-2  ${index > activeStep || reviewComplete ? ' text-gray-400' : 'font-bold'}`}
                                data-testid={`stepper-label:${index}`}
                            >
                                {item.stepLabel}
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}